import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { createEntity, getEntity, reset, updateEntity } from './favorite-truck.reducer';

export const FavoriteTruckUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const users = useAppSelector(state => state.userManagement.users);
  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const favoriteTruckEntity = useAppSelector(state => state.favoriteTruck.entity);
  const loading = useAppSelector(state => state.favoriteTruck.loading);
  const updating = useAppSelector(state => state.favoriteTruck.updating);
  const updateSuccess = useAppSelector(state => state.favoriteTruck.updateSuccess);

  const handleClose = () => {
    props.history.push('/favorite-truck' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getUsers({}));
    dispatch(getTruckImplements({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...favoriteTruckEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.userId.toString()),
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...favoriteTruckEntity,
          userId: favoriteTruckEntity?.user?.id,
          truckImplementId: favoriteTruckEntity?.truckImplement?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.favoriteTruck.home.createOrEditLabel" data-cy="FavoriteTruckCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.favoriteTruck.home.createOrEditLabel">Create or edit a FavoriteTruck</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="favorite-truck-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.favoriteTruck.favorited')}
                id="favorite-truck-favorited"
                name="favorited"
                data-cy="favorited"
                check
                type="checkbox"
              />
              <ValidatedField id="favorite-truck-user" name="userId" data-cy="user" label={translate('fleetSenseApp.favoriteTruck.user')} type="select">
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="favorite-truck-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.favoriteTruck.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/favorite-truck" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FavoriteTruckUpdate;
